export default __webpack_public_path__ + "static/media/farocg.2d84fab7.png";